import { render, staticRenderFns } from "./MarketingSupport.vue?vue&type=template&id=1270829c&scoped=true"
import script from "./MarketingSupport.vue?vue&type=script&lang=js"
export * from "./MarketingSupport.vue?vue&type=script&lang=js"
import style0 from "./MarketingSupport.vue?vue&type=style&index=0&id=1270829c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1270829c",
  null
  
)

export default component.exports